import styled from "styled-components";

export const FilterContainer = styled.div`
  margin-bottom: 0.5rem;
`;

export const FilterExtendedContainer = styled.div`
  margin-top: 0.75rem;
`;
